// extracted by mini-css-extract-plugin
module.exports = {"userDetail":"detail_userDetail_1jWK_","menu":"detail_menu_RNOn7","routeContent":"detail_routeContent_1lkvF"};